// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"831bbdba","453":"72dbb2ab","732":"14fd908c","977":"d59a9a40"}[chunkId] + ".chunk.js";
};